module.exports = __webpack_public_path__ + "static/media/2020-dec-1.b0c48266.png";